import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, SettingsIcon } from 'lucide-react';
import { AvisAtna } from '../components/avis/AvisAtna';
import { ImportantForYou } from '../components/avis/ImportantForYou';
import { NoticeFeed, type NoticeFilter } from '../components/avis/NoticeFeed';
export function AvisNotifications() {
  const [filter, setFilter] = useState<NoticeFilter>('All');
  const handleChip = (chip: string) => {
    if (chip === 'My important alerts') setFilter('Important');
    if (chip === 'Unread') setFilter('Unread');
    if (chip === 'This week') setFilter('All');
  };
  return <main className="bg-white" data-id="element-1924" data-mp="382ageya6nzri">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1925" data-mp="380zbgv504lyt">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-1926" data-mp="3c2kp4ipd14a2">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1927" data-mp="3napdh8y0b5g">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1928" data-mp="1o6z55nzygu15" />
          <span aria-current="page" data-id="element-1929" data-mp="1o78wpg0nf98y">Notifications</span>
        </nav>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-1930" data-mp="1j8xn96e9n0r9">
          <div data-id="element-1931" data-mp="1xxan4egh53r1">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1932" data-mp="1xxu2bneqpe1d">
              Notifications
            </h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-1933" data-mp="1t3zbm00pvyss">Stay on top of what concerns you.</p>
          </div>
          <Link to="/notifications/settings" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1934" data-mp="26zbdqsh7crjq">
            <SettingsIcon className="h-4 w-4" aria-hidden="true" data-id="element-1935" data-mp="mionjl1c3p1e" />
            Settings
          </Link>
        </header>

        <div className="mt-8" data-id="element-1936" data-mp="hk3npmpzv7dh">
          <AvisAtna onFilter={handleChip} data-id="element-1937" data-mp="hkvfemgh0kyh" />
        </div>

        <ImportantForYou data-id="element-1938" data-mp="2hm3eq6qay308" />
        <NoticeFeed filter={filter} onFilterChange={setFilter} data-id="element-1939" data-mp="2hmv3oype92hj" />
      </div>
    </main>;
}